import React, { useState, useEffect, useRef } from 'react';
import Quagga from 'quagga';
import Scanner from './scanner';

function App() {


  return (
    <div>
<Scanner />
    </div>
  );
}


export default App;
